import { render, staticRenderFns } from "./PackagesTable.vue?vue&type=template&id=44ac879d&scoped=true"
import script from "./PackagesTable.vue?vue&type=script&lang=ts"
export * from "./PackagesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac879d",
  null
  
)

export default component.exports